import { RefreshCw } from 'lucide-react';
import UIStrings from '@/Utils/UIStrings';

const AtsSyncingNotice = () => {
    return (
        <>
            <div className="flex flex-col items-center gap-3 py-6 text-center" data-cy="AtsSyncingNotice">
                <div className="bg-muted text-muted-foreground rounded-full p-3">
                    <RefreshCw className="size-6 animate-spin" aria-hidden />
                </div>
                <p className="text-secondary-foreground text-base font-semibold">{UIStrings.AtsSyncInProgressTitle}</p>
                <p className="text-muted-foreground max-w-md text-sm">{UIStrings.AtsSyncInProgressDescription}</p>
                <p className="text-muted-foreground max-w-md text-sm">{UIStrings.AtsSyncInProgressHint}</p>
            </div>
        </>
    );
};

export default AtsSyncingNotice;
